import { AcceptItem } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const getCurrentUserAcceptItems: (
  fetchContext: FetchContext,
  userId: number,
  accessToken?: string,
) => Promise<AcceptItem[]> = (fetchContext, userId, accessToken) => fetch(`${fetchContext.baseUrl}/api/users/${userId}/need-to-accept-items`,
  {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<AcceptItem[]>(fetchContext.errorStore, response, 'get current user accept items'));
